// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".boxStart{margin-top:3%}#logo{width:9%;margin-bottom:42px;background:#4575B4;border-radius:20px;padding:5px}.home_title{padding:20px}.yellowDivider{height:2px;border:0;margin:15px auto 25px auto;width:100%;background-color:#fad35f}.data_info{border:2px solid #f0f0f0;border-radius:5px;min-height:100px;text-align:center;padding:1%;margin:1%;font-weight:600;font-size:1.2rem}\n", ""]);
// Exports
module.exports = exports;
